import { defineAsyncComponent } from 'vue';

const DownloadClientToolPopup = defineAsyncComponent(() => import('@/views/toolClient/DownloadClientToolPopup.vue'));

export function registerClientTool(app) {
  app.component('DownloadClientToolPopup', DownloadClientToolPopup);
}
